/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  UnpauseReminderMutationResponse,
  UnpauseReminderPathParams,
  UnpauseReminder400,
  UnpauseReminder403,
  UnpauseReminder404,
  UnpauseReminder500,
} from '../types/UnpauseReminder'

function getUnpauseReminderUrl({
  id,
}: {
  id: UnpauseReminderPathParams['id']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/reminders/reminders/${id}/unpause/` as const,
  }
  return res
}

/**
 * @description Unpause a recurring reminder.
 * This endpoint:
 * - Recreates the celery beat scheduled task
 * - Updates reminder status to ACTIVE
 * - Recalculates end_date for occurrence-based reminders
 * - Only works for paused recurring reminders
 * - Checks if end_date has passed (marks as ENDED if so)
 * Args:
 * request: The HTTP request
 * pk: The reminder ID
 * Returns:
 * Response with success message or error details
 * @summary Unpause a recurring reminder
 * {@link /api/v1/reminders/reminders/:id/unpause/}
 */
export async function unpauseReminder(
  { id }: { id: UnpauseReminderPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    UnpauseReminderMutationResponse,
    ResponseErrorConfig<
      | UnpauseReminder400
      | UnpauseReminder403
      | UnpauseReminder404
      | UnpauseReminder500
    >,
    unknown
  >({
    method: 'POST',
    url: getUnpauseReminderUrl({ id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
